import { useAnalytics } from './useAnalytics';

export const useEmailAnalytics = () => {
  const { trackCustomEvent } = useAnalytics();

  const defaultProperties = {
    screen_context: 'email_form',
  };

  const trackFirstEmailTouch = () => {
    trackCustomEvent('funnel_screen_click', {
      ...defaultProperties,
      value: 'click_to_fill',
    });
  };

  const trackFirstEmailChange = () => {
    trackCustomEvent('funnel_screen_click', {
      ...defaultProperties,
      value: 'start_to_fill',
    });
  };

  const trackEmailFilled = (email: string) => {
    trackCustomEvent('funnel_screen_click', {
      ...defaultProperties,
      value: 'filled',
      email,
    });
  };

  return {
    trackFirstEmailTouch,
    trackFirstEmailChange,
    trackEmailFilled,
  };
};
